/**
 * ── **텔레포터** — `src/game/teleport.ts` 의 짝 ──
 *
 * ⚠ **여기는 요금을 *보여주기만* 한다.** 실제 판정은 서버가 한다.
 * 화면이 낸 숫자와 서버가 받은 숫자가 다르면 **서버 쪽이 맞다** —
 * 이 파일은 누르기 전에 "얼마인지" 를 알려주는 것까지다.
 *
 * ⚠ **좌표를 안 보낸다.** 클라가 좌표를 보내면 아무 데나 간다.
 * `send({ t:'teleport', to: stop.id })` — **정류장 id 만** 간다.
 * 그래서 이 파일에 `arriveAt` 이 없다. 내려서는 자리는 서버만 안다.
 *
 * 정류장은 손으로 안 적는다 — 서버와 똑같이 **지도에서 도출한다.**
 * 마을이나 갱도 입구가 하나 늘면 **여기도 저절로 는다.**
 * (`check-mirror` 가 `STOPS` 와 `teleportFee` 결과를 서버와 대조한다)
 */
import { CAVE_MOUTHS, SETTLEMENTS, FAIRY_FOREST } from './map.js';
import { nativeVillageEntrance } from './native-village.js';

/**
 * 갱도 입구 이름 — `chain` 에서 낸다. **서버 `caveKo` 와 한 글자도 다르면 안 된다**
 * (`check-mirror` 가 함수 결과를 대조한다).
 */
function caveKo(id) {
  const m = CAVE_MOUTHS.find((q) => q.id === id);
  return m.name;
}

/** 갈 수 있는 곳 — **지도에서 도출한다** */
export const STOPS = [
  ...SETTLEMENTS.map((s) => {
    const at = s.id === 'native_village' ? nativeVillageEntrance() : { x: s.x, y: s.y };
    return { id: `s:${s.id}`, ko: s.ko, x: at.x, y: at.y,
      lvMin: s.lvMin, lvMax: s.lvMax, kind: 'settle' };
  }),
  { id: 'f:fairy', ko: '요정숲 입구', x: FAIRY_FOREST.entranceX, y: FAIRY_FOREST.entranceY, lvMin: 50, lvMax: 70, kind: 'field' },
  ...CAVE_MOUTHS.map((m) => ({ id: `c:${m.id}`, ko: caveKo(m.id), x: m.x, y: m.y,
    lvMin: m.lvMin, lvMax: m.lvMax, kind: 'cave' })),
];

export const stopById = (id) => STOPS.find((s) => s.id === id);

/** 최저 요금 */
export const TELEPORT_MIN = 10;
/** 타일당 은화 */
export const TELEPORT_PER_TILE = 0.5;

/**
 * **얼마인가.** ⚠ **버림이 아니라 반올림이다** — 유저가 *내는* 돈이라
 * 올림·반올림이 세계에 은화를 만들지 않는다. 서버와 같은 식이어야 한다.
 */
export function teleportFee(fromX, fromY, to) {
  const d = Math.hypot(to.x - fromX, to.y - fromY);
  return Math.max(TELEPORT_MIN, Math.round(d * TELEPORT_PER_TILE));
}
